import { getRelativeAssetSize } from 'helpers/getRelativeAssetSize'
import { ImageAsset, VideoAsset } from 'models/Asset'
import { isText } from 'Util/assets'
import { getImageAspectRatio } from '~/Util/sourceFile'

export function createAssetFromSourceFile(file, { startTime,
  layerId,
  pregeneratedId,
  creationOrder,
  videoSize,
  aspectRatio }) {
  const fileData = {
    layerId,
    startTime,
    creationOrder,
  }

  if (file instanceof ImageAsset || isText(file.type)) {
    const { size, originalSize } = file.settings
    const { height, width } = size
    fileData.settings = {
      ...file.settings,
      ...(file instanceof ImageAsset
        ? { relativeSize: getRelativeAssetSize({ width, height }, videoSize) }
        : {}),
      aspectRatio: aspectRatio || getImageAspectRatio({ width, height }),
    }
    if (!originalSize) {
      fileData.settings.originalSize = fileData.settings.size
    }
  }

  // A 90/270 degrees rotated media file has swapped display dims relative to its
  // raw storage dims, so swap them and fit the asset within the reference area.
  if (file instanceof VideoAsset && [ 90, 270 ].includes(file.rotationDegrees)) {
    const rotatedWidth = file.height
    const rotatedHeight = file.width
    const fitScale = videoSize
      ? Math.min(videoSize.width / rotatedWidth, videoSize.height / rotatedHeight)
      : 1

    fileData.width = rotatedWidth
    fileData.height = rotatedHeight
    fileData.settings = {
      ...file.settings,
      size: { width: rotatedWidth * fitScale, height: rotatedHeight * fitScale },
      originalSize: { width: rotatedWidth, height: rotatedHeight },
    }
  }

  return file.clone(fileData, { pregeneratedId })
}

export const createGroupAssetsFromSourceFiles = (files, {
  startTime,
  startTimeByAssetId,
  layerId,
  pregeneratedIds, // for single file
  creationOrderByLayerId,
  videoSize,
  aspectRatio,
  isSourceFile,
}) => {
  let startAssetTime = startTime
  return files.map((file, index) => {
    const newAsset = createAssetFromSourceFile(file, {
      startTime: isSourceFile ? startAssetTime : startTimeByAssetId[file.id],
      // file?.layerId - if redo assets
      layerId: isSourceFile ? layerId : file?.layerId,
      pregeneratedId: pregeneratedIds[index],
      creationOrder: isSourceFile
        ? creationOrderByLayerId[layerId]
        : creationOrderByLayerId[file.layerId],
      videoSize,
      aspectRatio,
    })
    startAssetTime += file.duration
    return newAsset
  })
}
